var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBizvecimg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34376 3.21875C4.41177 3.21875 3.65626 3.97426 3.65626 4.90625C3.65626 5.83824 4.41177 6.59375 5.34376 6.59375C6.27576 6.59375 7.03126 5.83824 7.03126 4.90625C7.03126 3.97426 6.2754 3.21875 5.34376 3.21875ZM15.7184 0.125H2.21837C1.00724 0.125 -0.000305176 1.13223 -0.000305176 2.375V13.625C-0.000305176 14.8678 1.00692 15.875 2.21805 15.875H15.7181C16.9608 15.875 17.9681 14.8678 17.9681 13.625V2.375C17.9684 1.13223 16.991 0.125 15.7184 0.125ZM16.2809 13.3895L11.4715 6.85391C11.3836 6.69219 11.1832 6.59375 10.9688 6.59375C10.7539 6.59375 10.5532 6.69106 10.434 6.85317L6.68638 11.9192L5.38244 10.2985C5.26146 10.148 5.06835 10.0591 4.86318 10.0591C4.65779 10.0591 4.46486 10.148 4.34357 10.2985L1.68857 13.5965C1.68857 13.5955 1.68857 13.5975 1.68857 13.5965L1.68716 2.375C1.68716 2.06485 1.93951 1.8125 2.24966 1.8125H15.7497C16.0598 1.8125 16.3122 2.06485 16.3122 2.375V13.3895H16.2809Z",
    fill: "#6A7D95"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizvecimg);
export default __webpack_public_path__ + "static/media/bizvecimg.bbf3f28c88c4b4fc89185661fd433377.svg";
export { ForwardRef as ReactComponent };